<template>
    <div class="my-4 col-sm-12 text-center dark">
        <loader></loader>
    </div>
</template>

<script>
import Loader from '@/tools/loaders/loader1'
export default {
    data: function() {
        return {

        }
    },
    components: {
        Loader
    }
}
</script>



// WEBPACK FOOTER //
// ProductLoading.vue?6e47e5ba